// extracted by mini-css-extract-plugin
export default {"tooltip":"kW-z","arrow":"lW-z"};